import partner from './partner'
import teamLead from './team-lead'
import teamLeadOffice from './team-lead-office'

export default [...partner, ...teamLead, ...teamLeadOffice]
